{
  "validations": {
    "required": "Detta fält är obligatoriskt",
    "email": "Ogiltig e-postadress",
    "workflow": {
      "rejectCommentRequired": "Kommentar är obligatorisk för avvisning"
    },
    "contributorOwnerMustBeInCategory": "Ägare med rollen redigerare måste vara i samma kategori som dokumentet",
    "contributorPublisherMustBeInCategory": "Utgivare med rollen redigerare måste vara i samma kategori som dokumentet",
    "startDateRequired": "Startdatum saknas",
    "endDateAfter": "Slutdatum måste vara efter startdatum",
    "startDateMustNotBeInPast": "Startdatum får inte vara i det förflutna",
    "endDateMustNotBeInPast": "Slutdatum får inte vara i det förflutna"
  }
}
